<template>
  <div class="relative w-full flex mb-2 timeline-step" :class="{ completed }">
    <div class="relative inset-auto left-0 mr-4 timeline-step-checkbox">
      <div
        class="relative rounded-full w-6 h-6 mt-4 border-2 border-white fill-current z-10"
        :class="{
          'text-success': completed,
          'text-danger': active && !completed,
          'bg-gray-300': !active && !completed,
        }"
      >
        <svg-vue v-if="completed" icon="check" :class="checkboxClasses" />
        <svg-vue v-if="active && !completed" icon="exclamation-mark" :class="exclamationClasses" />
      </div>
    </div>
    <div class="flex-1 shadow p-4 bg-coral-100" :class="{ 'bg-coral-300': active && !completed }">
      <div class="cursor-pointer flex justify-between select-none fill-current text-black" @click="toggleStep(step.id)">
        <span class="font-montserrat text-xl font-medium" v-text="name" />
        <svg-vue icon="chevron-up" class="h-6 transform transition-all duration-300" :class="{ 'rotate-180': open }" />
      </div>

      <div
        v-show="open"
        class="transition-opacity duration-300 ease-in-out"
        :class="{ 'opacity-0': !open, 'opacity-100': open }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex';

export default Vue.extend({
  name: 'TimelineStep',
  props: {
    step: {
      type: Object,
      default: () => ({
        name: '',
        completed: false,
        open: false,
      }),
    },
  },
  data: () => ({}),
  computed: {
    checkboxClasses() {
      const classes = ['h-5'];

      classes.push(this.completed ? 'visible' : 'invisible');

      return classes.join(' ');
    },
    exclamationClasses() {
      const classes = ['h-5'];

      classes.push(!this.completed && this.active ? 'visible' : 'invisible');

      return classes.join(' ');
    },
    name() {
      return this.step.name;
    },
    completed() {
      return this.step.completed;
    },
    open() {
      return this.step.open;
    },
    active() {
      return this.step.active;
    },
  },
  methods: {
    ...mapMutations('timeline', ['toggleStep']),
  },
});
</script>

<style lang="postcss">
.timeline-step {
  @apply relative;

  &:last-child {
    &:after {
      @apply hidden;
    }
  }

  &:before,
  &:after {
    content: '';
    width: 4px;
    height: 100%;
    z-index: 0;
    margin-left: 10px;
    left: 0;
    right: auto;

    @apply absolute top-0 bg-gray-200;
  }

  &:after {
    top: 20px;
  }

  &:after {
    top: 20px;
  }

  @apply z-10;

  &.completed {
    &:after,
    &:before {
      @apply bg-coral-300;
    }
  }
}
</style>
